"use client";
import React, { useEffect, useState } from "react";
import {
  getDestinations as getDefaultDestinations,
  type Destination,
} from "@/app/utils/destinations/destinationData";
import {
  getCountryCodeFromLocalStorage,
  setCountryCodeToLocalStorage,
} from "@/app/utils/services/service/localStorageService";
import { getDestinations } from "@/app/utils/destinations/countryToRegion";
import { getRegionalDestinations } from "@/app/utils/apis/apiService";
import PlaceSection from "@/app/components/pages/Home/PlaceSection/PlaceSection";
import { useLocale, useTranslations } from "next-intl";

const TopDestinations = () => {
  const locale = useLocale();
  const t = useTranslations();
  const [destinations, setDestinations] = useState<Destination[]>(
    getDefaultDestinations(t)
  );

  const fetchDestinations = async () => {
    const countryCode = getCountryCodeFromLocalStorage();
    if (countryCode) {
      const regionDestinations = getDestinations(t, countryCode);
      setDestinations(regionDestinations);
    } else {
      const data = await getRegionalDestinations(locale);
      setDestinations(data.destinations);
      setCountryCodeToLocalStorage(data.countryCode);
    }
  };

  useEffect(() => {
    fetchDestinations();
  }, []);

  return <PlaceSection destinations={destinations} />;
};

export default TopDestinations;
